import weblayouts from "./blocks/weblayouts/client";
import templates from "./templates/client";
import * as welcomeTour from "./welcomeTour/client";
import * as tooltips from "./tooltips/client";

export default [...weblayouts, ...templates, welcomeTour, tooltips];
